export default __webpack_public_path__ + "static/media/Facebook.a86e9cc9.svg";